import { combineReducers } from 'redux';

import union from 'lodash/union';

import * as types from '../../../types/static-catalogs/cellular-providers';
import configurations from '../../configurations';

const byId = (state = {}, action) => {
  switch (action.type) {
    //TYPES COMPLETED FETCH, ADD AND EDIT
    case types.PROVIDERS_FETCH_COMPLETED: {
      const { entities, order } = action.payload;
      const newState = { ...state };
      order.forEach((providerId) => {
        newState[providerId] = {
          isSelected: false,
          ...entities[providerId],
          isConfirmed: true
        };
      });
      return newState;
    }

    //DEFAULT
    default: {
      return state;
    }
  }
};

const order = (state = [], action) => {
  switch (action.type) {
    //CASE COMPLETED FETCH, ADD AND REMOVE
    case types.PROVIDERS_FETCH_COMPLETED: {
      const { order } = action.payload;
      return union(order);
    }

    //DEFAULT
    default: {
      return state;
    }
  }
};

// STATES TO KNOW IF IT IS FETCHING, ADDING  OR EDITING
const isFetchingList = (state = false, action) => {
  switch (action.type) {
    case types.PROVIDERS_FETCH_STARTED: {
      return true;
    }
    case types.PROVIDERS_FETCH_COMPLETED:
    case types.PROVIDERS_FETCH_FAILED: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const errorFetchingList = (state = null, action) => {
  switch (action.type) {
    case types.PROVIDERS_FETCH_FAILED: {
      const { error } = action.payload;
      return error;
    }
    case types.PROVIDERS_FETCH_STARTED:
    case types.PROVIDERS_FETCH_COMPLETED: {
      return null;
    }
    default: {
      return state;
    }
  }
};

const providers = combineReducers({
  byId,
  order,
  isFetchingList,
  errorFetchingList,
  configurations
});

export default providers;

//Own state
export const getOwnState = (state) => state.staticCatalogs.providers;

//Information
export const getProvider = (state, providerId) => getOwnState(state).byId[providerId];
export const getProvidersList = (state) =>
  getOwnState(state).order.map((id) => getProvider(state, id));
export const getProvidersListByCountry = (state, countryId) =>
  getProvidersList(state).filter((provider) => provider.countryId === countryId);

export const getSelectedProviders = (state) => {
  const selectedProviders = getProvidersList(state).filter((provider) => provider.isSelected);
  //Si no se selecciona ninguno devuelve null
  if (selectedProviders.length === 0) return null;
  //Si se selecciona más de cero se devuelve el arreglo de los seleccionados
  if (selectedProviders.length > 0) return selectedProviders;
};
export const getProvidersFromBrand = (state, brandId) =>
  getProvidersList(state).filter((provider) => provider.brandId === brandId);

export const getSelectedProvider = (state) => {
  const selectedProviders = getProvidersList(state).filter((provider) => provider.isSelected);
  //Si se selecciona solo uno devuelve solo el seleccionado
  if (selectedProviders.length === 1) return selectedProviders[0];
  //De lo contrario se devuelve null
  else return null;
};

//Status of sagas
export const isFetchingProvider = (state) => getOwnState(state).isFetching;
export const isFetchingListProviders = (state) => getOwnState(state).isFetchingList;

//Errors
export const getFetchingProviderErrors = (state) => getOwnState(state).errorFetching;
export const getFetchingListProvidersErrors = (state) => getOwnState(state).errorFetchingList;
